import React from "react";
import { Link } from "react-router-dom";
import { CHENNAI_AREA_PAGES, getAreaPath } from "../data/chennaiAreaPages";
import { CITY_SEO_PAGES, getCityPath } from "../data/citySeoPages";
import "../styles/ServiceAreas.css";

/**
 * Visible service-coverage hub for users + crawlers (no cloaking).
 */
const ServiceAreasHub = ({ compact = false }) => {
  const featuredCities = CITY_SEO_PAGES.filter((c) =>
    ["coimbatore", "madurai", "hyderabad", "vijayawada", "tirupati", "salem"].includes(c.slug)
  );

  return (
    <section className={`service-areas${compact ? " service-areas--compact" : ""}`} aria-labelledby="service-areas-heading">
      <h2 id="service-areas-heading">Chenda Melam Across Chennai &amp; South India</h2>
      <p className="service-areas-intro">
        Book Kerala Chenda Melam for wedding in your neighbourhood or city. Browse our Chennai area pages and South India city pages below.
      </p>

      <h3 className="service-areas-sub">Chennai areas</h3>
      <nav className="service-areas-links" aria-label="Chennai area pages">
        {CHENNAI_AREA_PAGES.map((a) => (
          <Link key={a.slug} to={getAreaPath(a.slug)}>
            Chenda Melam {a.name}
          </Link>
        ))}
      </nav>

      <h3 className="service-areas-sub">Popular cities</h3>
      <nav className="service-areas-links" aria-label="City pages">
        {featuredCities.map((c) => (
          <Link key={c.slug} to={getCityPath(c.slug)}>
            Chenda Melam {c.name}
          </Link>
        ))}
        <Link to="/contact?type=wedding&form=open">Book any city →</Link>
      </nav>
    </section>
  );
};

export default ServiceAreasHub;
